import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import { FormControl, InputLabel, Input, Select, MenuItem, Button, FormControlLabel, Checkbox, IconButton } from '@material-ui/core';
import { QuestionClassTypes, InputTypes } from '../../constants/data';
import QuestionOptionsComponent from './QuestionOptionsComponent';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import QuestionValidationComponent from './QuestionValidationComponent';
import SkipLogicComponent from './SkipLogicComponent';
import AutoCalculationComonent from './AutoCalculationComponent';
import { Guid } from 'guid-typescript';
import CommonMenuComponent from '../common/menu/CommonMenuComponent';
import ConfirmationComponent from '../common/notification/ConfirmationComponent';
import { MESSAGE_FOR_QUESTION_DELETE } from 'src/constants/NotificationMessageConstant';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import Replay from '@material-ui/icons/Replay';
import QuestionVersionComponent from './QuestionVersionComponent';
import { QuestionStatus, QuestionType } from 'src/constants/Enum/ModuleEnum';
import TextEditorComponent from '../common/editor/TextEditorComponent';
import QuestionDefaultAnswerComponent from './QuestionDefaultAnswerComponent';
import ReviewCommentComponent from '../reviewquetions/ReviewCommentComponent';
import { getAllReviewQuestionsComments } from '../../effects/api/api.module';

const menuItems: any = [
    {
        text: 'Show all versions',
        clickIdentifier: 'Version',
        icon: <Replay />,
        customCss: ''
    },
    {
        text: 'Delete Question',
        clickIdentifier: 'Delete',
        icon: <RemoveCircleIcon />,
        customCss: 'popperDropdownDangerMenuItem'
    }
];

export default class AddQuestionComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            errors: {},
            allData: {},
            queston: {},
            questionClassTypes: QuestionClassTypes,
            inputTypes: InputTypes,
            isMandatory: false,
            isAdminLevelAutoCalculate: false,
            limit: false,
            questionClassTypeId: 1,
            questionTooltip: '',
            questionTypeId: 1,
            questionTitle: '',
            questionNumber: '',
            showUnavailableCheckbox: false,
            showOtherTextbox: false,
            isImpactOnGlobal: false,
            visibleOptions: false,
            inputValue: '',
            classTypeValue: 1,
            showQuestionOptions: [],
            items: [],
            showValidationDialog: false,
            showVisibleIfDialog: false,
            showAutoCalculationDialog: false,
            minValue: '',
            maxValue: '',
            classOneTitle: '',
            classTwoTitle: '',
            classThreeTitle: '',
            showConfirmationDialog: false,
            openMenu: false,
            deletedQuestionIds: [],
            showVersionDialog: false,
            isQuestionDirty: false,
            showCommentsDialog: false,
            comments: []
        };

        this.handleClassTypes = this.handleClassTypes.bind(this);
        this.handleInputTypes = this.handleInputTypes.bind(this);
        this.handleTooltip = this.handleTooltip.bind(this);
        this.onBlurHandleTooltip = this.onBlurHandleTooltip.bind(this);
        this.handleTitle = this.handleTitle.bind(this);
        this.onBlurHandleTitle = this.onBlurHandleTitle.bind(this);
        this.handleMandatoryQuestion = this.handleMandatoryQuestion.bind(this);
        this.handleLimitChange = this.handleLimitChange.bind(this);
        this.handleQuestionNumber = this.handleQuestionNumber.bind(this);
        this.onBlurHandleQuestionNumber = this.onBlurHandleQuestionNumber.bind(this);

        this.handleCopyQuestion = this.handleCopyQuestion.bind(this);
        this.handleUnavailableCheckbox = this.handleUnavailableCheckbox.bind(this);
        this.handleOtherTextBox = this.handleOtherTextBox.bind(this);
        this.handleIsImpactOnGlobal = this.handleIsImpactOnGlobal.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleVisibleIf = this.handleVisibleIf.bind(this);
        this.handleVisibleIfClose = this.handleVisibleIfClose.bind(this);
        this.handleAutoCalculation = this.handleAutoCalculation.bind(this);
        this.handleAutoCalculationClose = this.handleAutoCalculationClose.bind(this);
        this.handleMandatory = this.handleMandatory.bind(this);
        this.handleLimit = this.handleLimit.bind(this);
        this.handleMinValue = this.handleMinValue.bind(this);
        this.handleMaxValue = this.handleMaxValue.bind(this);

        this.handleClassOneTitle = this.handleClassOneTitle.bind(this);
        this.onBlurHandleClassOneTitle = this.onBlurHandleClassOneTitle.bind(this);
        this.handleClassTwoTitle = this.handleClassTwoTitle.bind(this);
        this.onBlurHandleClassTwoTitle = this.onBlurHandleClassTwoTitle.bind(this);
        this.handleClassThreeTitle = this.handleClassThreeTitle.bind(this);
        this.onBlurHandleClassThreeTitle = this.onBlurHandleClassThreeTitle.bind(this);
        this.handleMenuItem = this.handleMenuItem.bind(this);
        this.deleteQuestion = this.deleteQuestion.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.handleCloseConfirmation = this.handleCloseConfirmation.bind(this);
        this.handleMoveUp = this.handleMoveUp.bind(this);
        this.handleMoveDown = this.handleMoveDown.bind(this);
        this.updateHtmlFromEditor = this.updateHtmlFromEditor.bind(this);
        this.handleClickAway = this.handleClickAway.bind(this);
    }

    componentDidMount() {
        if (this.props.question) {
            const questionItems: any = Object.assign([], this.props.question.items);

            questionItems.clusterQuestionIndex = `${this.props.clusterIndex}${this.props.questionIndex}`;
            const itemString = JSON.stringify(questionItems);

            this.setState({
                allData: this.props.allData,
                question: this.props.question,
                questionClassTypeId: this.props.question.class_type,
                questionTooltip: this.props.question.tooltip.en,
                questionTypeId: this.props.question.input_type,
                questionTitle: this.props.question.title.en,
                questionNumber: this.props.question.question_number,
                inputValue: this.props.question.input_type,
                visibleOptions: this.props.question.input_type > QuestionType.Datepicker && this.props.question.input_type < QuestionType.Other && this.props.question.input_type !== QuestionType.AdminLevel,
                items: JSON.parse(itemString),
                showUnavailableCheckbox: this.props.question.show_unavailable_checkbox,
                showOtherTextbox: this.props.question.show_other_textbox,
                isImpactOnGlobal: this.props.question.is_impact_on_global,
                limits: this.props.question.limit,
                minValue: this.props.question.min_value ? this.props.question.min_value : '',
                maxValue: this.props.question.max_value ? this.props.question.max_value : '',
                isMandatory: this.props.question.ismandatory,
                isAdminLevelAutoCalculate: this.props.question.isAdminLevelAutoCalculate,
                classOneTitle: this.props.question.question_one_title ? this.props.question.question_one_title.en : '',
                classTwoTitle: this.props.question.question_two_title ? this.props.question.question_two_title.en : '',
                classThreeTitle: this.props.question.question_three_title ? this.props.question.question_three_title.en : '',
                errors: this.props.errors
            });

            if (this.props.question.input_type > QuestionType.Datepicker && this.props.question.input_type < QuestionType.Other && this.props.question.input_type !== QuestionType.AdminLevel) {
                this.setState({ showQuestionOptions: [...this.state.showQuestionOptions, `${this.props.clusterIndex}${this.props.questionIndex}`] })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const questionItems: any = Object.assign([], nextProps.question.items);
        questionItems.clusterQuestionIndex = `${this.props.clusterIndex}${this.props.questionIndex}`;
        const itemString = JSON.stringify(questionItems);
        const checkHintQuestion = nextProps.question.tooltip && nextProps.question.tooltip.en;
        this.setState({
            allData: nextProps.allData,
            question: nextProps.question,
            questionClassTypeId: nextProps.question.class_type,
            questionTooltip: checkHintQuestion === '<p><br></p>' ? '' : checkHintQuestion,
            questionTypeId: nextProps.question.input_type,
            questionTitle: nextProps.question.title && nextProps.question.title.en,
            questionNumber: nextProps.question.question_number,
            inputValue: nextProps.question.input_type,
            visibleOptions: this.props.question.input_type > QuestionType.Datepicker && this.props.question.input_type < QuestionType.Other && this.props.question.input_type !== QuestionType.AdminLevel,
            showUnavailableCheckbox: nextProps.question.show_unavailable_checkbox,
            showOtherTextbox: nextProps.question.show_other_textbox,
            isImpactOnGlobal: nextProps.question.is_impact_on_global,
            items: JSON.parse(itemString),
            limits: nextProps.question.limit,
            minValue: nextProps.question.min_value ? nextProps.question.min_value : '',
            maxValue: nextProps.question.max_value ? nextProps.question.max_value : '',
            isMandatory: nextProps.question.ismandatory,
            isAdminLevelAutoCalculate: nextProps.question.isAdminLevelAutoCalculate,
            classOneTitle: nextProps.question.question_one_title ? nextProps.question.question_one_title.en : '',
            classTwoTitle: nextProps.question.question_two_title ? nextProps.question.question_two_title.en : '',
            classThreeTitle: nextProps.question.question_three_title ? nextProps.question.question_three_title.en : '',
            errors: nextProps.errors
        });

        if (nextProps.question.input_type > QuestionType.Datepicker && nextProps.question.input_type < QuestionType.Other && nextProps.question.input_type !== QuestionType.AdminLevel) {
            this.setState({ showQuestionOptions: [...this.state.showQuestionOptions, `${nextProps.clusterIndex}${nextProps.questionIndex}`] })
        }

        this.setState({ openMenu: false });
    }

    handleClickAway = () => {
        this.setState({ openMenu: false });
    }

    handleLimitChange = (e: any) => {
        this.setState({ limits: e.target.checked, isQuestionDirty: true });
    }

    handleMandatoryQuestion = (e: any) => {
        this.setState({ isMandatory: e.target.checked, isQuestionDirty: true });
    }

    handleClassTypes = (e: any) => {
        this.setState({ classTypeValue: e.target.value, [e.target.name]: e.target.value, isQuestionDirty: true },
            () => {
                this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state[e.target.name] }, field: 'questionClassTypeId' })
            }
        );
    }

    handleInputTypes = (e: any) => {
        if (e.target.value > 3 && e.target.value < 8) {
            this.setState({ visibleOptions: true, inputValue: e.target.value })
        } else {
            this.setState({ visibleOptions: false, inputValue: e.target.value })
        }

        this.setState({ [e.target.name]: e.target.value, isQuestionDirty: true },
            () => this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state[e.target.name] }, field: 'questionTypeId' })
        );

        this.setState({ showQuestionOptions: [...this.state.showQuestionOptions, `${this.props.clusterIndex}${this.props.questionIndex}`] })
    }

    handleTooltip = (e: any) => {
        this.setState({ questionTooltip: e.target.value, isQuestionDirty: true });
    }

    onBlurHandleTooltip = () => {
        if (!this.state.isQuestionDirty) {
            return;
        }
        this.setState({ isQuestionDirty: false });

        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state.questionTooltip }, field: 'questionTooltip' })
    }

    handleTitle = (e: any) => {
        this.setState({ [e.target.name]: e.target.value, questionTitle: e.target.value, isQuestionDirty: true });
        delete this.state.errors[`questionTitle_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`];
    }

    onBlurHandleTitle = () => {
        if (!this.state.isQuestionDirty) {
            return;
        }

        this.setState({ isQuestionDirty: false });
        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state.questionTitle }, field: 'questionTitle' });
    }

    handleQuestionNumber = (e: any) => {
        this.setState({ [e.target.name]: e.target.value, questionNumber: e.target.value, isQuestionDirty: true });
    }

    onBlurHandleQuestionNumber = () => {
        if (!this.state.isQuestionDirty) {
            return;
        }

        this.setState({ isQuestionDirty: false });
        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state.questionNumber }, field: 'questionNumber' })
    }

    handleCopyQuestion = () => {
        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state.questionNumber }, field: 'copyQuestion' })
    }

    handleUnavailableCheckbox = (e: any) => {
        this.setState({ showUnavailableCheckbox: e.target.checked, isQuestionDirty: true },
            () => {
                this.props.updateModule({
                    data: {
                        pageNumber: this.props.pageNumber && this.props.pageNumber,
                        clusterIndex: this.props.clusterIndex,
                        questionIndex: this.props.questionIndex,
                        value: this.state.showUnavailableCheckbox
                    },
                    field: 'showUnavailableCheckbox'
                });
            });
    }

    handleOtherTextBox = (e: any) => {
        this.setState({ showOtherTextbox: e.target.checked, isQuestionDirty: true },
            () => {
                this.props.updateModule({
                    data: {
                        pageNumber: this.props.pageNumber && this.props.pageNumber,
                        clusterIndex: this.props.clusterIndex,
                        questionIndex: this.props.questionIndex,
                        value: this.state.showOtherTextbox
                    },
                    field: 'showOtherTextbox'
                });
            });
    }

    // handle impact global checkbox event
    handleIsImpactOnGlobal = (e: any) => {
        this.setState({
            isImpactOnGlobal: e.target.checked,
            isQuestionDirty: true
        },
            () => {
                this.props.updateModule({
                    data: {
                        pageNumber: this.props.pageNumber && this.props.pageNumber,
                        clusterIndex: this.props.clusterIndex,
                        questionIndex: this.props.questionIndex,
                        value: this.state.isImpactOnGlobal
                    },
                    field: 'isImpactOnGlobal'
                });
            });
    }

    handleValidation() {
        this.setState({ showValidationDialog: true });
    }

    handleClose(value: any) {
        this.setState({ showValidationDialog: !value });
    }

    handleVisibleIf() {
        this.setState({ showVisibleIfDialog: true });
    }

    handleVisibleIfClose(value: any) {
        this.setState({ showVisibleIfDialog: !value });
    }

    handleLimit = (clusterIndex: any, questionIndex: any, e: any) => {
        const name = `isChecked_${clusterIndex}${questionIndex}`;
        const minName = `minValue_${clusterIndex}${questionIndex}`;
        const maxName = `maxValue_${clusterIndex}${questionIndex}`;
        this.setState({ [name]: e.target.checked, [minName]: null, [maxName]: null, limits: e.target.checked, minValue: '', maxValue: '', isQuestionDirty: true },
            () =>
                this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: this.state[name] }, field: 'limit' }));
    }

    handleMandatory = (e: any) => {
        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: e.target.checked }, field: 'isMandatory' })
    }

    // event to handle admin level type question auto calculate
    handleAdminLevelAutoCalculate = (event: any) => {
        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: event.target.checked }, field: 'isAdminLevelAutoCalculate' })
    }

    handleMinValue = (e: any) => {
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: e.target.value !== '' ? parseInt(e.target.value, 10) : null
            },
            field: 'minValue'
        });
    }

    handleMaxValue = (e: any) => {
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: e.target.value !== '' ? parseInt(e.target.value, 10) : null
            },
            field: 'maxValue'
        });
    }

    handleClassOneTitle = (e: any) => {
        this.setState({ [e.target.name]: e.target.value, classOneTitle: e.target.value, isQuestionDirty: true });
    }

    onBlurHandleClassOneTitle = () => {
        if (!this.state.isQuestionDirty) {
            return;
        }

        this.setState({ isQuestionDirty: false });
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: this.state.classOneTitle
            },
            field: 'classOneTitle'
        });
    }

    handleClassTwoTitle = (e: any) => {
        this.setState({ [e.target.name]: e.target.value, classTwoTitle: e.target.value, isQuestionDirty: true });
    }

    onBlurHandleClassTwoTitle = () => {
        if (!this.state.isQuestionDirty) {
            return;
        }

        this.setState({ isQuestionDirty: false });
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: this.state.classTwoTitle
            },
            field: 'classTwoTitle'
        });
    }

    handleClassThreeTitle = (e: any) => {
        this.setState({ [e.target.name]: e.target.value, classThreeTitle: e.target.value, isQuestionDirty: true });
    }

    onBlurHandleClassThreeTitle = () => {
        if (!this.state.isQuestionDirty) {
            return;
        }

        this.setState({ isQuestionDirty: false });
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: this.state.classThreeTitle
            },
            field: 'classThreeTitle'
        });
    }

    handleAutoCalculation = () => {
        this.setState({ showAutoCalculationDialog: true });
    }

    handleAutoCalculationClose = (value: any) => {
        this.setState({ showAutoCalculationDialog: !value });
    }

    handleMenuItem = (menu: any) => {
        this.setState({ openMenu: false });
        switch (menu) {
            case 'Delete':
                this.setState({ showConfirmationDialog: true })
                break;
            case 'Version':
                this.setState({ showVersionDialog: true })
                break;
        }
    }

    deleteQuestion = () => {
        delete this.state.errors[`questionTitle_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`];
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                questionIndex: this.props.questionIndex,
                value: this.state.question.question_id
            },
            field: 'deleteQuestion'
        });
        setTimeout(() => this.props.onDeletePageChange(this.props.pageNumber), 100);
        this.setState({ showConfirmationDialog: false, openMenu: false });
    }

    openMenu = () => {
        this.setState({ openMenu: true, showConfirmationDialog: false });
    }

    onDialogClose = () => {
        this.setState({ showVersionDialog: false });
    }

    handleCloseConfirmation = () => {
        this.setState({ showConfirmationDialog: false });
    }

    handleMoveUp = () => {
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                moveFromIndex: this.props.questionIndex,
                moveToIndex: this.props.questionIndex !== 0 ? this.props.questionIndex - 1 : this.props.questionIndex
            },
            field: 'rearrange'
        });
    }

    handleMoveDown = () => {
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
                moveFromIndex: this.props.questionIndex,
                moveToIndex: this.props.questionIndex + 1
            },
            field: 'rearrange'
        });
    }

    updateHtmlFromEditor(htmlData: any) {
        if (htmlData) {
            this.setState({ isQuestionDirty: true });
            htmlData = htmlData.replace(/<a/g, '<a target="_blank"');
            this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: htmlData }, field: 'questionTooltip' })
        }
    }

    hanldeApplyVersion = (question: any) => {
        this.setState({
            question,
            isQuestionDirty: false
        }, () => {
            this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: question.title.en, isQuestionDirty: false, selectedQuestionVersion: question.version, question: { ...question } }, field: 'questionTitle' });
        })
    }

    // Update the default question responses for current question 
    updateDefaultQuestionResponses = (defaultQuestionResponses: any) => {
        this.props.updateModule({ data: { pageNumber: this.props.pageNumber && this.props.pageNumber, clusterIndex: this.props.clusterIndex, questionIndex: this.props.questionIndex, value: defaultQuestionResponses }, field: 'defaultQuestionResponses' });
    }

    // handle view all comments
    handleViewComments = (event: any, questionId: any) => {
        let comments: any = [];
        getAllReviewQuestionsComments({
            questionId
        }).then((res) => {
            if (res && res.data.success) {
                comments = res.data.payload;
            }

            this.setState({ showCommentsDialog: true, comments });
        });
    }

    // close comments view dialog
    handleShowAllCommentsClose(value: any) {
        this.setState({ showCommentsDialog: !value, comments: [] });
    }

    render() {
        const qType = `classType${this.props.clusterIndex}${this.props.questionIndex}`;
        const qName = `name${this.props.clusterIndex}${this.props.questionIndex}`;
        const ipType = `inputType${this.props.clusterIndex}${this.props.questionIndex}`;
        const questionNumber = `questionNumber${this.props.clusterIndex}${this.props.questionIndex}`;
        const isQuestionRender = this.state.showQuestionOptions.filter((item: any) => (item === `${this.props.clusterIndex}${this.props.questionIndex}`));
        const setTitleOne = `title1_${this.props.clusterIndex}${this.props.questionIndex}`;
        const setTitleTwo = `title2_${this.props.clusterIndex}${this.props.questionIndex}`;
        const setTitleThree = `title3_${this.props.clusterIndex}${this.props.questionIndex}`;
        return (
            <>
                {
                    this.state.question &&
                    <div className={(this.state.question.status === QuestionStatus.SubmittedForReview) || (this.props.userId === 1 && this.state.question.status === QuestionStatus.AssignToCreator) ? 'disableQuetionDiv' : ''}>
                        <Grid container={true} spacing={24}>
                            <Grid item={true} xs={1} className="queNo">
                                <Grid item={true} xs={6} >
                                    <FormControl margin="normal" fullWidth={false}>
                                        <InputLabel htmlFor="questionNumber">Q No.</InputLabel>
                                        <Input id="questionNumber"
                                            name={questionNumber}
                                            onChange={this.handleQuestionNumber}
                                            onBlur={this.onBlurHandleQuestionNumber}
                                            value={this.state.questionNumber || ''}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid item={true} xs={6} >
                                <Grid container={true} spacing={24}>
                                    <Grid item={true} xs={3}>
                                        <FormControl margin="normal" required={false} fullWidth={true}>
                                            <InputLabel htmlFor="classType">Class Type</InputLabel>
                                            <Select
                                                value={this.state.questionClassTypeId}
                                                onChange={this.handleClassTypes}
                                                input={<Input name="classtype" />}
                                                autoWidth={true}
                                                name={qType}
                                               
                                            >
                                                {
                                                    this.state.questionClassTypes.map((ct: any, index: any) => {
                                                        return (
                                                            <MenuItem key={index} value={ct.value}>Class Type {ct.text}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item={true} xs={1}>
                                        &nbsp;
                                    </Grid>
                                    <Grid item={true} xs={4}>
                                        <Grid container={true} spacing={40}>
                                            <Grid item={true} xs={1}>
                                                <IconButton className="copyButton" color="inherit" aria-label="Copy" value='Copy Question' onClick={this.handleCopyQuestion}>
                                                    <FileCopyIcon />
                                                </IconButton>
                                            </Grid>
                                            <Grid item={true} xs={1} className="handleMove">
                                                <IconButton className="moveUpDown" color="inherit" aria-label="Move Up Down" >
                                                    <ExpandLess onClick={this.handleMoveUp} className="moveUp" />
                                                    <ExpandMore onClick={this.handleMoveDown} className="moveDown" />
                                                </IconButton>
                                            </Grid>
                                            <Grid item={true} xs={1}>
                                                <CommonMenuComponent
                                                    onClickAway={this.handleClickAway}
                                                    key={`delete_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`}
                                                    open={this.state.openMenu}
                                                    icon={
                                                        <MoreVertIcon onClick={this.openMenu} />
                                                    }
                                                    menuItems={menuItems} onMenuItemClicked={this.handleMenuItem}
                                                />
                                                <ConfirmationComponent
                                                    key={`confirm_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`}
                                                    message={MESSAGE_FOR_QUESTION_DELETE}
                                                    open={this.state.showConfirmationDialog}
                                                    handleDialogSubmit={this.deleteQuestion}
                                                    onCloseConfirmation={this.handleCloseConfirmation}
                                                />
                                                {
                                                    this.state.showVersionDialog && (
                                                        <QuestionVersionComponent
                                                            question={this.state.question}
                                                            showDialog={this.state.showVersionDialog}
                                                            onDialogClose={this.onDialogClose}
                                                            onApplyVersionChanges={(question: any) => this.hanldeApplyVersion(question)}
                                                        />
                                                    )
                                                }

                                            </Grid>
                                            <Grid item={true} xs={1}>
                                                <div className='displayStatus'>
                                                    <span> Status: {this.state.question.status}</span>
                                                    {
                                                        this.state.question.status === QuestionStatus.AssignToCreator &&
                                                        <Button size="medium" className="btn-blue" variant="outlined" type="button" onClick={(event: any) => this.handleViewComments(event, this.props.question.question_id)} value="View Comments">View Comments</Button>
                                                    }
                                                </div>
                                            </Grid>
                                            {
                                                this.props.question.status === QuestionStatus.AssignToCreator && this.state.showCommentsDialog &&
                                                <ReviewCommentComponent
                                                    showCommentsDialog={this.state.showCommentsDialog}
                                                    onDialogClose={(value: any) => this.handleShowAllCommentsClose(value)}
                                                    questionId={this.props.question.question_id}
                                                    comments={this.state.comments}
                                                />
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container={true} spacing={24}>
                                    <Grid item={true} xs={4}>
                                        <Select
                                            value={this.state.questionTypeId}
                                            onChange={this.handleInputTypes}
                                            input={<Input name="inputtype" />}
                                            autoWidth={true}
                                            name={ipType}
                                        >
                                            {
                                                this.state.inputTypes.map((it: any, index: any) => {
                                                    return (
                                                        <MenuItem key={index} value={it.value}>{it.text}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Grid>
                                    <Grid item={true} xs={8}>
                                        <span className="btn-groups">
                                            {
                                                <Button size="medium" className="btn-blue" variant="outlined" type="button" value="Visibility Criteria"
                                                    onClick={this.handleVisibleIf}
                                                    disabled={this.props.pageNumber === 1 && this.props.questionIndex === 0 && this.props.clusterIndex === 0}
                                                >
                                                    {this.state.question.visibleIf && this.state.question.visibleIf.length === 0 ? 'Visible If' : 'Edit Visible If'}
                                                </Button>
                                            }
                                            <Button size="medium" className="btn-blue" variant="outlined" type="button" value="Add Validation"
                                                disabled={this.state.limits && this.state.questionTypeId === 2}
                                                onClick={this.handleValidation}>
                                                {this.state.question.validations && this.state.question.validations.length === 0 ? 'Add Validation' : 'Edit Validation'}
                                            </Button>
                                            <span hidden={this.state.questionTypeId !== QuestionType.Numeric && this.state.questionTypeId !== QuestionType.AdminLevel} >
                                                <Button size="medium" className="btn-blue" variant="outlined" type="button" value="Auto Calculation"
                                                    onClick={this.handleAutoCalculation}>
                                                    Auto Calculation
                                                </Button>
                                            </span>
                                        </span>
                                        {
                                            this.state.showValidationDialog && (
                                                <>
                                                    <QuestionValidationComponent
                                                        key={Guid.create().toString()}
                                                        showDialog={this.state.showValidationDialog}
                                                        QuestionClassTypeId={this.state.questionClassTypeId}
                                                        pageNumber={this.props.pageNumber}
                                                        clusterIndex={this.props.clusterIndex}
                                                        questionIndex={this.props.questionIndex}
                                                        onClose={this.handleClose}
                                                        allData={this.state.allData}
                                                        question={this.state.question}
                                                        updateModule={this.props.updateModule}
                                                    />
                                                </>
                                            )
                                        }
                                        {
                                            this.state.showVisibleIfDialog &&
                                            (<SkipLogicComponent
                                                key={Guid.create().toString()}
                                                showVisibleIfDialog={this.state.showVisibleIfDialog}
                                                pageNumber={this.props.pageNumber}
                                                clusterIndex={this.props.clusterIndex}
                                                questionIndex={this.props.questionIndex}
                                                onDialogClose={this.handleVisibleIfClose}
                                                allData={this.state.allData}
                                                question={this.state.question}
                                                updateModule={this.props.updateModule}
                                            />
                                            )
                                        }
                                        {
                                            this.state.showAutoCalculationDialog && (this.state.questionTypeId === QuestionType.Numeric || this.state.questionTypeId === QuestionType.AdminLevel) && (
                                                <AutoCalculationComonent
                                                    key={Guid.create().toString()}
                                                    showDialog={this.state.showAutoCalculationDialog}
                                                    questionTypeId={this.state.questionTypeId}
                                                    pageNumber={this.props.pageNumber}
                                                    clusterIndex={this.props.clusterIndex}
                                                    questionIndex={this.props.questionIndex}
                                                    onClose={this.handleAutoCalculationClose}
                                                    allData={this.state.allData}
                                                    question={this.state.question}
                                                    updateModule={this.props.updateModule}
                                                />
                                            )
                                        }
                                    </Grid>
                                </Grid>
                                <Grid container={true} spacing={24}>
                                    <Grid item={true} xs={12}>
                                        <FormControl margin="normal" required={true} fullWidth={true}>
                                            <InputLabel htmlFor="questionName">Question Name</InputLabel>
                                            <Input id={qName} name={qName} multiline={true}
                                                onChange={this.handleTitle}
                                                onBlur={this.onBlurHandleTitle}
                                                value={this.state.questionTitle ? this.state.questionTitle : ''}
                                            />
                                            {
                                                this.state.errors && this.state.errors[`questionTitle_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] && (
                                                    <span className="error" >{this.state.errors[`questionTitle_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`]}</span>
                                                )
                                            }
                                        </FormControl>
                                    </Grid>
                                    {
                                        // this.state.questionTypeId !== QuestionType.AdminLevel &&
                                        <>
                                            <Grid item={true} xs={4} >
                                                <FormControl margin="normal" required={false} fullWidth={false}>
                                                    <InputLabel htmlFor="setOneTitle">Class One Title</InputLabel>
                                                    <Input id="setOneTitle" name={setTitleOne} multiline={false}
                                                        onChange={this.handleClassOneTitle}
                                                        onBlur={this.onBlurHandleClassOneTitle}
                                                        value={this.state.classOneTitle ? this.state.classOneTitle : ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item={true} xs={4} hidden={!(this.state.questionClassTypeId >= 2)}>
                                                <FormControl margin="normal" required={false} fullWidth={true}>
                                                    <InputLabel htmlFor="setTwoTitle">Class Two Title</InputLabel>
                                                    <Input id="setTwoTitle" name={setTitleTwo} multiline={false}
                                                        onChange={this.handleClassTwoTitle}
                                                        onBlur={this.onBlurHandleClassTwoTitle}
                                                        value={this.state.classTwoTitle ? this.state.classTwoTitle : ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item={true} xs={4} hidden={!(this.state.questionClassTypeId === 3)}>
                                                <FormControl margin="normal" required={false} fullWidth={true}>
                                                    <InputLabel htmlFor="setThreeTitle">Class Three Title</InputLabel>
                                                    <Input id="setThreeTitle" name={setTitleThree} multiline={false}
                                                        onChange={this.handleClassThreeTitle}
                                                        onBlur={this.onBlurHandleClassThreeTitle}
                                                        value={this.state.classThreeTitle ? this.state.classThreeTitle : ''}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                            <Grid xs={1} item={true}>
                                &nbsp;
                            </Grid>
                            <Grid xs={4} item={true}>
                                <FormControl margin="normal" fullWidth={true}>
                                    <InputLabel htmlFor="questionHint">Add hint text</InputLabel>
                                </FormControl>
                                <TextEditorComponent updateHtmlFromEditor={this.updateHtmlFromEditor} htmlInput={this.state.questionTooltip || ''} />
                            </Grid>
                        </Grid>
                        <Grid container={true} spacing={24}>
                            <Grid xs={1} item={true}>
                                &nbsp;
                            </Grid>
                            <Grid item={true} xs={6}>
                                {
                                    this.state.inputValue > QuestionType.Datepicker && this.state.inputValue !== QuestionType.AdminLevel && this.state.inputValue < QuestionType.Other && isQuestionRender && isQuestionRender.length ? (
                                        <div className="optionsWrapper">
                                            <QuestionOptionsComponent
                                                key={Guid.create().toString()}
                                                selectedInput={this.state.inputValue}
                                                selectedClassType={this.state.classTypeValue}
                                                pageNumber={this.props.pageNumber}
                                                clusterIndex={this.props.clusterIndex}
                                                questionIndex={this.props.questionIndex}
                                                updateModule={this.props.updateModule}
                                                dataSource={this.state.items}
                                                clusterQuestionIndex={`${this.props.clusterIndex}${this.props.questionIndex}`}
                                                errors={this.state.errors}
                                                question={this.state.question}
                                            />
                                        </div>
                                    ) : ''
                                }
                            </Grid>
                        </Grid>
                        {
                            this.state.questionTypeId === QuestionType.AdminLevel &&
                            <Grid container={true} spacing={24} >
                                <Grid item={true} xs={1}>&nbsp;</Grid>
                                <Grid item={true} xs={3}>
                                    <FormControlLabel className="isMandatory"
                                        control={
                                            <Checkbox
                                                checked={this.state.isAdminLevelAutoCalculate}
                                                onChange={this.handleAdminLevelAutoCalculate}
                                            />
                                        }
                                        label="Show Auto-Calculated Total"
                                    />
                                </Grid>
                            </Grid>
                        }
                        <Grid container={true} spacing={24} >
                            <Grid item={true} xs={1}>&nbsp;</Grid>
                            <Grid item={true} xs={3}>
                                <FormControlLabel className="isMandatory"
                                    control={
                                        <Checkbox
                                            checked={this.state.isMandatory}
                                            onChange={this.handleMandatory}
                                        />
                                    }
                                    label="Is Mandatory"
                                />
                            </Grid>
                        </Grid>
                        <div hidden={!(this.state.questionTypeId === QuestionType.Numeric || this.state.questionTypeId === QuestionType.AdminLevel)}>
                            <Grid container={true} spacing={8} >
                                <Grid item={true} xs={1}>&nbsp;</Grid>
                                <Grid item={true} xs={1}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.limits}
                                                onChange={this.handleLimit.bind(this, this.props.clusterIndex, this.props.questionIndex)}
                                            />
                                        }
                                        label="Limits"
                                    />
                                </Grid>
                                <Grid item={true} xs={1}>
                                    <div>
                                        <FormControl margin="normal" fullWidth={true}
                                            disabled={!(this.state[`isChecked_${this.props.clusterIndex}${this.props.questionIndex}`] || this.state.limits)}
                                        >
                                            <InputLabel htmlFor="minValue">Min Value</InputLabel>
                                            <Input id="minValue" name={`minValue_+${this.props.clusterIndex}${this.props.questionIndex}`} type="number"
                                                value={this.state.minValue}
                                                onChange={this.handleMinValue}
                                            />
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl margin="normal" fullWidth={true}
                                            disabled={!(this.state[`isChecked_${this.props.clusterIndex}${this.props.questionIndex}`] || this.state.limits)}
                                        >
                                            <InputLabel htmlFor="maxValue">Max Value</InputLabel>
                                            <Input id="maxValue" name={`maxValue_+${this.props.clusterIndex}${this.props.questionIndex}`} type="number"
                                                value={this.state.maxValue}
                                                onChange={this.handleMaxValue}
                                            />
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <Grid container={true} spacing={24}>
                            <Grid xs={1} item={true}>
                                &nbsp;
                            </Grid>
                            {/* show only on textbox/numeric/datepicker*/}
                            <Grid item={true} xs={2} hidden={!(this.state.questionTypeId === QuestionType.Textbox || this.state.questionTypeId === QuestionType.Numeric
                                || this.state.questionTypeId === QuestionType.Datepicker || this.state.questionTypeId === QuestionType.AdminLevel)
                            }>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.showUnavailableCheckbox}
                                            onChange={this.handleUnavailableCheckbox}
                                        />
                                    }
                                    label="Show unavailable textbox"
                                />
                            </Grid>
                            {/* dropdown/radiobutton/checkbox */}
                            <Grid item={true} xs={2} hidden={!(this.state.questionTypeId > QuestionType.Datepicker && this.state.questionTypeId < QuestionType.Other && this.state.questionTypeId !== QuestionType.AdminLevel)}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.showOtherTextbox}
                                            onChange={this.handleOtherTextBox}
                                        />
                                    }
                                    label="Show other textbox"
                                />
                            </Grid>
                        </Grid>
                        <Grid container={true} spacing={24}>
                            <Grid item={true} xs={1}>&nbsp;</Grid>
                            <Grid item={true} xs={3}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.isImpactOnGlobal}
                                            onChange={this.handleIsImpactOnGlobal}
                                        />

                                    }
                                    label="This question has impact on Global level monitoring estimates"
                                />
                            </Grid>
                        </Grid>
                        <QuestionDefaultAnswerComponent
                            classTypeId={this.state.questionClassTypeId}
                            inputType={this.state.questionTypeId}
                            defaultQuestionResponses={this.state.question.default_question_responses}
                            updateDefaultQuestionResponses={this.updateDefaultQuestionResponses}
                            pageNumber={this.props.pageNumber}
                            clusterIndex={this.props.clusterIndex}
                            questionIndex={this.props.questionIndex}
                            options={this.state.items}
                            isAutoCalculationApply={(this.state.question.auto_calculation_config.vertical_config && Object.keys(this.state.question.auto_calculation_config.vertical_config).length > 0) ||
                                (this.state.question.auto_calculation_config.horizontal_config && Object.keys(this.state.question.auto_calculation_config.horizontal_config).length > 0) ? true : false}
                        />
                    </div>
                }
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions/AddQuestionComponent.tsx